import { useEffect, useState } from "react";

const delay = (i, gold) => (i < gold ? i * 220 : gold * 220 + (i - gold) * 200);

function Pegs({ gold, silver, fresh }) {
  return (
    <div className="grid grid-cols-2 gap-1">
      {[0, 1, 2, 3].map((i) => (
        <span key={i} style={fresh ? { animationDelay: `${delay(i, gold)}ms` } : undefined}
          className={`w-3.5 h-3.5 rounded-full ${i < gold ? "bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.8)]" : i < gold + silver ? "bg-slate-300" : "bg-white/10"} ${fresh && i < gold + silver ? "vault-peg-in" : ""}`} />
      ))}
    </div>
  );
}

export function VaultHistory({ mine, fresh }) {
  if (!mine.length) return <p className="text-sm text-white/50 text-center py-3" data-testid="vault-history-empty">Noch kein Versuch in diesem Tresor – dein erster Tipp verrät dir schon viel.</p>;
  return (
    <ul className="space-y-1.5" data-testid="vault-history">
      {[...mine].reverse().map((t, i) => (
        <li key={t.guess} data-testid={`vault-try-${t.guess}`} className={`flex items-center gap-3 rounded-2xl px-3 py-2 ${t.guess === fresh ? "bg-white/10 vault-row-in" : "bg-white/5"}`}>
          <span className="text-[11px] text-white/40 w-5 tabular-nums">{mine.length - i}.</span>
          <span className="flex gap-1">{t.guess.split("").map((d, j) => <span key={j} className="w-8 h-9 rounded-lg bg-slate-800 grid place-items-center font-black">{d}</span>)}</span>
          <span className="ml-auto flex items-center gap-2"><span className="text-xs text-white/60 tabular-nums">{t.gold} Gold · {t.silver} Silber</span><Pegs gold={t.gold} silver={t.silver} fresh={t.guess === fresh} /></span>
        </li>
      ))}
    </ul>
  );
}

const STATES = ["", "out", "in"];

export function VaultNotes({ roundNo }) {
  const key = `vault-notes-${roundNo}`;
  const [n, setN] = useState(() => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; } });
  useEffect(() => { localStorage.setItem(key, JSON.stringify(n)); }, [key, n]);
  const tap = (d) => setN((x) => ({ ...x, [d]: STATES[(STATES.indexOf(x[d] || "") + 1) % 3] }));
  return (
    <div data-testid="vault-notes">
      <p className="text-xs font-bold text-white/60 mb-2">Dein Notizblock – tippe Ziffern an: durchgestrichen = kommt nicht vor, grün = sicher drin</p>
      <div className="grid grid-cols-10 gap-1">
        {"0123456789".split("").map((d) => (
          <button key={d} onClick={() => tap(d)} data-testid={`vault-note-${d}`}
            className={`h-9 rounded-lg font-black text-sm transition-colors ${n[d] === "out" ? "bg-white/5 text-white/25 line-through" : n[d] === "in" ? "bg-emerald-500/80 text-white" : "bg-white/10 text-white"}`}>{d}</button>
        ))}
      </div>
    </div>
  );
}
